import React, { useState } from 'react';
import { LuChevronRight, LuChevronLeft, LuCheck } from "react-icons/lu"; 
import "../../asset/css/register.css"; 
import { baseurl } from '../../baseurl';
import axios from 'axios';
import Swal from 'sweetalert2';

const PlanDetail = () => {
  const [selectedPlan, setSelectedPlan] = useState('access');
  const [loading, setLoading] = useState(false);

  // 1. Get and Parse user session
  const sessionData = localStorage.getItem('user_session');
  const userSession = sessionData ? JSON.parse(sessionData) : null;

  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true
  });

  // 2. Handle Plan Submission
  const handleCompleteSetup = async () => {
    if (!userSession || !userSession.userInfo) {
      Toast.fire({
        icon: 'error',
        title: 'Session expired. Please register again.'
      });
      return;
    }

    const payload = {
      userId: userSession.userInfo.id,
      email: userSession.userInfo.email,
      planType: selectedPlan,
    };

    console.log("Sending Plan Data:", payload);
    setLoading(true);

    try {
      // Replace 'updatePlan' with your actual backend endpoint
      const response = await axios.post(`${baseurl}updateUserPlan`, payload);

      if (response.status === 200 || response.status === 201) {
        Toast.fire({
          icon: 'success',
          title: 'Plan selected! Confirming...'
        });
        
        // Redirect to dashboard or next setup phase
        setTimeout(() => {
          window.location.href = '/register-successful';
        }, 2000);
      }
    } catch (error) {
      console.error("Plan Update Error:", error);
      Toast.fire({
        icon: 'error',
        title: error.response?.data?.message || 'Failed to update plan.'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-wrapper">
      <nav className="reg-nav">
        <div className="reg-logo">
          <div className="logo-icon"></div>
          <span>Measro <span className="dot">.</span></span>
        </div>
      </nav>

      <div className="reg-container wide">
        <div className="stepper">
          <div className="step-item active">
            <div className="step-circle success"><LuCheck /></div>
            <span className="step-label">Create Account</span>
          </div>
          <div className="step-line active"></div>
          <div className="step-item active">
            <div className="step-circle">2</div>
            <span className="step-label">Choose Plan</span>
          </div>
        </div>

        <div className="plan-selection-card">
          <header className="reg-header">
            <h1>Choose Your Plan</h1>
            <p>Welcome back, {userSession?.userInfo?.first_name || 'User'}!</p>
          </header>

          <div className="plan-grid">
            <div 
              className={`plan-card ${selectedPlan === 'access' ? 'selected' : ''}`} 
              onClick={() => setSelectedPlan('access')}
            >
              <div className="badge trial">7-Day Free Trial</div>
              <h3>Measro Access</h3>
              <div className="price">$10 <span>per month</span></div>
              <div className="credits-highlight">$5 free credits every month</div>
              <ul className="plan-features">
                <li><LuCheck className="check-icon" /> 7-day free trial</li>
                <li><LuCheck className="check-icon" /> Property search & map navigation</li>
                <li><LuCheck className="check-icon" /> Accurate GIS-based area measurements</li>
                <li><LuCheck className="check-icon" /> Professional PDF measurement reports</li>
                <li><LuCheck className="check-icon" /> Email support</li>
                <li><LuCheck className="check-icon" /> $5 monthly free credits</li>
              </ul>
            </div>

            <div 
              className={`plan-card ${selectedPlan === 'pro' ? 'selected' : ''}`} 
              onClick={() => setSelectedPlan('pro')}
            >
              <div className="badge popular">Most Popular</div>
              <h3>Measro Pro</h3>
              <div className="price">$59 <span>per month</span></div>
              <div className="credits-highlight">$30 credits included every month</div>
              <ul className="plan-features">
                <li><LuCheck className="check-icon" /> Everything in Access plan</li>
                <li><LuCheck className="check-icon" /> PDF + Excel report formats</li>
                <li><LuCheck className="check-icon" /> Faster turnaround time</li>
                <li><LuCheck className="check-icon" /> Chat support (business hours)</li>
                <li><LuCheck className="check-icon" /> $30 monthly included credits</li>
                <li><LuCheck className="check-icon" /> Priority processing</li>
              </ul>
            </div>
          </div>

          <div className="credits-section">
            <h3>Need More Credits? Buy Additional Credits</h3>
            <div className="credits-table-container">
              <table className="credits-table">
                <thead>
                  <tr>
                    <th>Credits Package</th>
                    <th>Price</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr><td>10 Credits</td><td>$10</td><td>1 credit = $1</td></tr>
                  <tr><td>25 Credits</td><td>$23</td><td>Save 8%</td></tr>
                  <tr><td>50 Credits</td><td>$45</td><td>Save 10%</td></tr>
                  <tr><td>100 Credits</td><td>$85</td><td>Save 15%</td></tr>
                </tbody>
              </table>
            </div>
            <p className="credits-note">
              <strong>How credits work:</strong> 1 credit = $1. Free credits reset monthly. Paid credits never expire. Credits are used for measurement reports and advanced features.
            </p>
          </div>

          <div className="reg-footer plan-footer">
            <button type="button" className="btn-back" onClick={() => window.history.back()}>
              <LuChevronLeft /> Back
            </button>
            <button 
              type="button" 
              className="btn-continue" 
              onClick={handleCompleteSetup}
              disabled={loading}
            >
              {loading ? 'Processing...' : 'Complete Setup & Start Trial'} <LuChevronRight />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanDetail;